import { Serializable } from "../core";
import { Color } from "./color";

export class ProductAttribute implements Serializable<ProductAttribute> {
  id!: string;
  size!: string;
  color!: Color;
  price!: number;
  offPrice!: number;
  sizeDescription!: string;
  count!: number;

  public isAvailable(): boolean {
    return this.count !== 0;
  }

  public hasOff(): boolean {
    return this.offPrice !== 0;
  }

  deserialize(json: any): ProductAttribute {
    this.id = json.id.toString();
    this.size = json.size.size;
    this.color = new Color().deserialize(json.color);
    this.price = json.price;
    this.offPrice = json.off_price;
    this.sizeDescription = json.size_description;
    this.count = json.count;
    return this;
  }
}
